import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledFilterButtonLabel = styled.div`
    display: flex;
    min-width: 0;
    white-space: nowrap;
    max-width: 372px;
    overflow: hidden;
    ${setFontVariant("h6", colorsPalettes.carbon["400"])};
`;
